module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 12.c4d68fb4.png";